export default __webpack_public_path__ + "static/lace-b66eaba63b4e6e9d909652838862fb83.jpg";